import React, { useState } from "react";
import { Link2, Check } from "lucide-react";
import { XLogo, WhatsappLogo, FacebookLogo, LinkedinLogo } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function ShareBar({ article, darkMode }) {
  const [copied, setCopied] = useState(false);
  const url = `${window.location.origin}${window.location.pathname}?essay=${article.id}`;
  const text = `${article.title}, Mind & Mizan`;

  const channels = [
    { id: "x", label: "X", href: `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`, Icon: XLogo },
    { id: "whatsapp", label: "WhatsApp", href: `https://wa.me/?text=${encodeURIComponent(`${text}\n${url}`)}`, Icon: WhatsappLogo },
    { id: "facebook", label: "Facebook", href: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`, Icon: FacebookLogo },
    { id: "linkedin", label: "LinkedIn", href: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`, Icon: LinkedinLogo },
  ];

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success("Essay link copied, share it wherever hearts gather.");
      setTimeout(() => setCopied(false), 2200);
    } catch {
      toast.error("Could not copy the link.");
    }
  };

  const btnCls = `w-11 h-11 rounded-full border flex items-center justify-center transition-all duration-300 hover:-translate-y-0.5 hover:border-[#B85D34] hover:text-[#B85D34] ${darkMode ? "border-[#3A4048] bg-[#181C22]" : "border-[#E6DEC7] bg-[#F4EFE6]"}`;

  return (
    <div data-testid="share-bar" className="flex flex-wrap items-center gap-3">
      <span className="text-xs uppercase tracking-[0.2em] opacity-60 font-semibold mr-1">Share this essay</span>
      {channels.map(({ id, label, href, Icon }) => (
        <a
          key={id}
          data-testid={`share-btn-${id}`}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`Share on ${label}`}
          title={`Share on ${label}`}
          className={btnCls}
        >
          <Icon size={16} />
        </a>
      ))}
      <button data-testid="share-copy-link" onClick={copyLink} aria-label="Copy essay link" title="Copy link" className={btnCls}>
        {copied ? <Check size={16} className="text-emerald-600" /> : <Link2 size={16} />}
      </button>
    </div>
  );
}
